
import moment from "moment";
import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Badge,
  Form, Table
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { CompanyContext, RegulationContext } from "../../../../App";
import Pagination from "../../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
  STATUS
} from "../../../../core/constants/common";
import FormService from "../../../../core/service/FormService";
import "../Forms.scss";
import nodataimg from "../../../../images/nodatafound.png";
import { FcFinePrint } from "react-icons/fc";


function OpenFormSubmissions({ t }) {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [forms, setForms] = useState([]);

  const { glbRegulation } = useContext(RegulationContext);
  const { glbCompany } = useContext(CompanyContext);

  const glbRegulationId = glbRegulation?.id ?? 0;
  const glbCompanyId = glbCompany?.companyId ?? 0;


  const listForms = useCallback((
    pageNumber,
    itemsPerPageVal,
    sortFieldName
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    let perPage;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    var sort = sortFieldName + "," + order;
    var data = JSON.parse(localStorage.getItem("authority"));
    const supplierId = data.profile.company.id;
    FormService.listOpenFormsForSupplier(
      pageNumber,
      perPage,
      sort,
      supplierId,
      glbCompanyId || 0,
      glbRegulationId || 0
    ).then((response) => {
      var totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setForms([...response.data]);
    }).catch((error) => {
    });
  }, [itemsPerPage, order, glbRegulationId, glbCompanyId]);

  useEffect(() => {
    listForms(0, itemsPerPage, sortField);
  }, [listForms, glbRegulationId, glbCompanyId, sortField, itemsPerPage]);

  return (
    <div className='List_Table_01'>
      <div className='List_table-card01'>
        <Table responsive="sm">
          <thead>
            <tr>
              <th className="th_check">
                <Form.Check
                  inline
                  name="group1"
                  type="checkbox"
                  id="inline-checkbox-1"

                />
              </th>
              <th>{t("FormTitle.label")}</th>
              <th>{t("LastModified.label")}</th>
              <th>{t("Status.label")}</th>
              {/* <th>{t("Progress.label")}</th> */}
            </tr>
          </thead>
          <tbody>
            {
              forms.length > 0
                ? <>{
                  forms.map((form, index) => {
                    return <tr key={index}>
                      <td className="Single_check_width">
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"

                        />
                      </td>
                      <td>{form?.form?.name}</td>
                      <td>
                        {
                          form.lastModifiedDate
                            ? moment(form.lastModifiedDate).format("MMM DD, YYYY , h:mm:ss a")
                            : "-"
                        }
                      </td>
                      <td>
                        {(() => {
                          switch (form.status) {
                            case "IN_PROGRESS":
                              return (
                                <Badge bg="badge-Inprogress">
                                  {STATUS[form.status]}
                                </Badge>
                              );

                            case "NEW":
                              return (
                                <Badge bg="badge-new">
                                  {STATUS[form.status]}
                                </Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      {/* <td>
                        <ProgressBar variant="warning" now={0} label={`0%`} />
                      </td> */}
                    </tr>
                  })
                }</>
                : <tr>
                  <td colSpan="4" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
            }
          </tbody>
        </Table>
        {itemsTotalCount > 10 && <div className="p-2 List_footer_count">
          <Pagination
            itemsTotalCount={itemsTotalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            alwaysShown={true}
            setItemsPerPage={setItemsPerPage}
            pageClicked={(pageNum, perPage) => {
              listForms(pageNum, perPage, sortField);
            }}
          />
        </div>}
      </div>
    </div>
  );
}

export default withTranslation()(OpenFormSubmissions);
